import { CollapseToggle } from './collapse';

const SELECTORS = {
    QUESTION: '.js-faq-overview-question',
    TOGGLE: '.js-faq-overview-question-toggle',
};

const QUESTIONS = [...document.querySelectorAll(SELECTORS.QUESTION)];
const FAQ_COLLAPSES = [];

function initFaqOverview() {
    if (QUESTIONS.length > 0) {
        const { history, location } = window;
        const { hash } = location;

        QUESTIONS.forEach((question) => {
            const { id } = question;
            const toggle = question.querySelector(SELECTORS.TOGGLE);
            const target = question.querySelector(toggle.dataset.target);
            const collapse = new CollapseToggle(toggle, target);

            toggle.addEventListener('click', (e) => {
                e.preventDefault();

                if (collapse.isOpen) {
                    collapse.hideContent();
                    history.replaceState(null, null, ' ');
                } else {
                    collapse.showContent();
                    history.pushState(null, null, `#${id}`);
                }
            });

            FAQ_COLLAPSES.push({ id, collapse });
        });

        if (hash) {
            const toOpen = FAQ_COLLAPSES.filter((obj) => obj.id === hash.split('#')[1])[0];
            const { collapse } = toOpen;

            collapse.showContent();
        }
    }
}

export { initFaqOverview };
